import clsx from 'clsx'
import React, { FC } from 'react'
import { Link } from 'react-router-dom'
import { useLayout } from '../../../core/LayoutProvider'
import { usePageData } from '../../../core/PageData'
import { getSelectedLocation } from '../../../../../utils/index'

const DefaultTitle: FC = () => {
  const { pageTitle, pageDescription, pageBreadcrumbs } = usePageData()
  const { config, classes } = useLayout()

  // Seçili konum bilgisini al
  const selectedLocation = getSelectedLocation()
  const isBanned = selectedLocation?.is_active === "0" || selectedLocation?.is_active === 0
  const bannedReason = selectedLocation?.banned_reason

  return (
    <>
      <style>{`
        .dt-title {
          font-size: 18px;
          font-weight: 700;
          letter-spacing: -.01em;
          color: var(--bs-gray-900, #181c32);
          margin: 0;
          line-height: 1.3;
        }
        html[data-theme-mode='dark'] .dt-title {
          color: #f5f5f5;
        }
        .dt-desc {
          font-size: 12px;
          font-weight: 500;
          color: var(--bs-gray-500, #a1a5b7);
          margin-left: 10px;
          padding-left: 10px;
          border-left: 1px solid var(--bs-gray-300, #e4e6ef);
        }
        html[data-theme-mode='dark'] .dt-desc {
          color: #6d6d80;
          border-color: #2d2d43;
        }
        /* Breadcrumb */
        .dt-breadcrumb {
          display: flex; align-items: center;
          list-style: none; margin: 0; padding: 0;
          gap: 0;
        }
        .dt-breadcrumb li {
          display: flex; align-items: center;
          font-size: 12px; font-weight: 500;
        }
        .dt-breadcrumb .bc-link {
          color: var(--bs-gray-500, #a1a5b7);
          text-decoration: none;
          transition: color .15s;
        }
        .dt-breadcrumb .bc-link:hover {
          color: var(--theme-primary, #009ef7);
        }
        html[data-theme-mode='dark'] .dt-breadcrumb .bc-link {
          color: #565674;
        }
        html[data-theme-mode='dark'] .dt-breadcrumb .bc-link:hover {
          color: var(--theme-primary, #009ef7);
        }
        .dt-breadcrumb .bc-sep {
          width: 4px; height: 4px; border-radius: 50%;
          background: var(--bs-gray-300, #e4e6ef);
          margin: 0 6px;
        }
        html[data-theme-mode='dark'] .dt-breadcrumb .bc-sep {
          background: #363650;
        }
        .dt-breadcrumb .bc-current {
          color: var(--bs-gray-700, #5e6278);
          font-weight: 600;
        }
        html[data-theme-mode='dark'] .dt-breadcrumb .bc-current {
          color: #cdcdde;
        }

        /* BAN ALERT STYLES */
        .ban-alert-wrapper {
          margin-top: 16px;
          animation: slideDown 0.3s ease-out;
        }

        @keyframes slideDown {
          from {
            opacity: 0;
            transform: translateY(-10px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        .ban-alert {
          display: flex;
          align-items: flex-start;
          gap: 12px;
          padding: 12px 16px;
          background: linear-gradient(135deg, #fff5f5 0%, #ffe6e6 100%);
          border: 1px solid #ffd4d4;
          border-radius: 6px;
          border-left: 4px solid #dc3545;
        }

        html[data-theme-mode='dark'] .ban-alert {
          background: linear-gradient(135deg, #3d1f1f 0%, #531818 100%);
          border-color: #7a2020;
          border-left-color: #ff6b6b;
        }

        .ban-alert-icon {
          flex-shrink: 0;
          width: 20px;
          height: 20px;
          display: flex;
          align-items: center;
          justify-content: center;
        }

        .ban-alert-icon svg {
          width: 100%;
          height: 100%;
          color: #dc3545;
        }

        html[data-theme-mode='dark'] .ban-alert-icon svg {
          color: #ff6b6b;
        }

        .ban-alert-content {
          flex: 1;
          min-width: 0;
        }

        .ban-alert-title {
          font-size: 13px;
          font-weight: 600;
          color: #dc3545;
          margin: 0 0 4px 0;
        }

        html[data-theme-mode='dark'] .ban-alert-title {
          color: #ff6b6b;
        }

        .ban-alert-message {
          font-size: 12px;
          color: #a94442;
          margin: 0;
          line-height: 1.4;
          word-break: break-word;
        }

        html[data-theme-mode='dark'] .ban-alert-message {
          color: #c97a7a;
        }
      `}</style>

      <div
        id='kt_page_title'
        data-kt-swapper='false'
        data-kt-swapper-mode='prepend'
        data-kt-swapper-parent="{default: '#kt_content_container', 'lg': '#kt_toolbar_container'}"
        className={clsx('page-title d-flex flex-column justify-content-center', classes.pageTitle.join(' '))}
      >
        {/* Başlık + açıklama */}
        {pageTitle && (
          <div className='d-flex align-items-center'>
            <h1 className='dt-title'>{pageTitle}</h1>
            {pageDescription && config.pageTitle?.description && (
              <span className='dt-desc'>{pageDescription}</span>
            )}
          </div>
        )}

        {/* BAN ALERT */}
        {isBanned && (
          <div className='ban-alert-wrapper'>
            <div className='ban-alert'>

              <div className='ban-alert-content'>
                <p className='ban-alert-title'>🚫 Bu konum devre dışı bırakılmıştır</p>
                <p className='ban-alert-message'>
                  {bannedReason ? `Sebep: ${bannedReason}` : 'Bu konuma erişim şu anda mümkün değildir.'}
                </p>
              </div>
            </div>
          </div>
        )}

        {/* Breadcrumb */}
        {pageBreadcrumbs &&
          pageBreadcrumbs.length > 0 &&
          config.pageTitle?.breadCrumbs && (
            <ul className='dt-breadcrumb mt-1'>
              {Array.from(pageBreadcrumbs).map((item, index) => (
                <li key={`${item.path}${index}`}>
                  {!item.isSeparator ? (
                    <Link
                      className={clsx('bc-link', { 'bc-current': item.isActive })}
                      to={item.path}
                    >
                      {item.title}
                    </Link>
                  ) : (
                    <span className='bc-sep' />
                  )}
                </li>
              ))}
              <li>
                <span className='bc-sep' />
                <span className='bc-current'>{pageTitle}</span>
              </li>
            </ul>
          )}
      </div>
    </>
  )
}

export { DefaultTitle }